<template>
    <b-row>
        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <b-row>
                <b-col v-if="!isReadOnly" cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Data Inizio</label>
                    <date-picker v-model="jsonData.dataInizio" format="DD-MM-YYYY" value-type="timestamp" type="date"></date-picker>
                </b-col>
                <b-col v-if="!isReadOnly" cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Data Fine</label>
                    <date-picker v-model="jsonData.dataFine" format="DD-MM-YYYY" value-type="timestamp" type="date"></date-picker>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Familiare Riferimetno</label>
                    <b-form-input v-if="!isReadOnly" v-model="nominativoPersonaRiferimento" :disabled="isPersonaRiferimento"> </b-form-input>
                    <span v-else>{{ nominativoPersonaRiferimento }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Telefono</label>
                    <b-form-input v-if="!isReadOnly" v-model="personaRiferimento.cellulare" :disabled="isPersonaRiferimento"> </b-form-input>
                    <span v-else>{{ personaRiferimento.cellulare }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Amm. Sostegno</label>
                    <b-form-input v-if="!isReadOnly" v-model="jsonData.amministratoreSostegno"> </b-form-input>
                    <span v-else>{{ jsonData.amministratoreSostegno }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Telefono</label>
                    <b-form-input v-if="!isReadOnly" v-model="jsonData.amministratoreSostegnoTelefono"> </b-form-input>
                    <span v-else>{{ jsonData.amministratoreSostegnoTelefono }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Equipè Inviante</label>
                    <b-form-input v-if="!isReadOnly" v-model="jsonData.equipeInviante"> </b-form-input>
                    <span v-else>{{ jsonData.equipeInviante }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                    <label class="sa-label-data">Case Manager DSM</label>
                    <b-form-input v-if="!isReadOnly" v-model="jsonData.caseManagerDsm"> </b-form-input>
                    <span v-else>{{ jsonData.caseManagerDsm }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                    <label class="sa-label-data">Case Manager CTA</label>
                    <b-form-input v-if="!isReadOnly" v-model="jsonData.caseManagerCta"> </b-form-input>
                    <span v-else>{{ jsonData.caseManagerCta }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Diagnosi All'Ingresso</label>
                    <b-form-textarea v-if="!isReadOnly" v-model="jsonData.diagnosiIngresso" rows="3" max-rows="6"></b-form-textarea>
                    <span v-else>{{ jsonData.diagnosiIngresso }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Diagnosi Alla Stesura</label>
                    <b-form-textarea v-if="!isReadOnly" v-model="jsonData.diagnosiStesura" rows="3" max-rows="6"></b-form-textarea>
                    <span v-else>{{ jsonData.diagnosiStesura }}</span>
                </b-col>
            </b-row>
        </b-col>
    </b-row>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import DatePicker from "vue2-datepicker";
export default {
    components: { DatePicker },
    mixins: [UtilityMixin],
    props: {
        idRisorsa: {
            type: String,
            default: function () {
                return null;
            },
        },
        idAccettazione: {
            type: String,
            default: function () {
                return null;
            },
        },
        isReadOnly: {
            type: Boolean,
        },
    },

    data() {
        return {
            pathResourche: "/rsapazientesrdiangosi",
            pathResourcePersonaRiferimento: "/rsapersoneriferimento",
            isPersonaRiferimento: true,
            nomeProgetto: "DIAGNOSI",
            jsonData: {
                id: null,
                idAccettazione: null,
                amministratoreSostegno: "",
                amministratoreSostegnoTelefono: "",
                caseManagerSdm: "",
                caseManagerCta: "",
                diagnosiIngresso: "",
                diagnosiStesura: "",
                equipeInviante: "",
                idPersonaRiferimento: "",
                params: "",
                nomeProgetto: "",
            },
            params: "",
            personaRiferimento: { telefono: "" },
            nominativoPersonaRiferimento: "",
        };
    },
    mounted() {
        let me = this;
        me.idAccettazione = me.$route.query.idAccettazione ? me.$route.query.idAccettazione : me.$route.params.id;
        let params = { diagnosi: "si" };
        me.params = JSON.stringify(params);
        me.jsonData = {
            id: null,
            idAccettazione: me.idAccettazione,
            amministratoreSostegno: "",
            amministratoreSostegnoTelefono: "",
            caseManagerDsm: "",
            caseManagerCta: "",
            diagnosiIngresso: "",
            diagnosiStesura: "",
            equipeInviante: "",
            idPersonaRiferimento: "",
            params: me.params,
            nomeProgetto: me.nomeProgetto,
            dataInizio: new Date().getTime(),
        };

        if (me.idRisorsa !== null) {
            me.loadData();
        }
        me.loadPersonaRiferimento();
    },
    watch: {
        jsonData: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
        },
    },
    methods: {
        loadData() {
            let me = this;
            me.loadDataResources(me.pathResourche + "/" + me.idRisorsa, {}, me.resultResponseData, me.resultErrorData);
        },
        resultResponseData(response) {
            let me = this;
            me.jsonData = response.data.data;
            me.jsonData.nomeProgetto = me.nomeProgetto;
            me.jsonData.params = me.params;
            me.jsonData.idAccettazione = me.idAccettazione;
        },
        resultErrorData(error) {
            console.log(error.response.data.messaggio);
        },
        loadPersonaRiferimento() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourcePersonaRiferimento, { idAccettazione: me.idAccettazione }, me.resultResponsePersonaRiferimento, me.resultErrorPersonaRiferimento);
        },
        resultResponsePersonaRiferimento(response) {
            let me = this;
            me.jsonData.idPersonaRiferimento = "";
            if (response.data.data.list.length > 0) {
                me.personaRiferimento = response.data.data.list[0];
                me.nominativoPersonaRiferimento = me.personaRiferimento.nome + " " + me.personaRiferimento.cognome + " (" + me.personaRiferimento.gradoRelazione + ")";
                me.jsonData.idPersonaRiferimento = me.personaRiferimento.id;
            }
        },
        resultErrorPersonaRiferimento(error) {
            console.log(error.response);
        },
    },
};
</script>
